const state = {
  count: 13
}

const getters = {
  getCount: state => state.count
}

export default {
  state,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/navLinks.js